import { render } from "./AttendancePerParticipants.vue?vue&type=template&id=6bece9f6&scoped=true"
import script from "./AttendancePerParticipants.vue?vue&type=script&lang=js"
export * from "./AttendancePerParticipants.vue?vue&type=script&lang=js"

import "./AttendancePerParticipants.vue?vue&type=style&index=0&id=6bece9f6&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bece9f6"]])

export default __exports__